export const NEW_AUTOMATION_FORM = "marketplaceNewAutomationForm";